module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Redirect URL</span></div>\r\n<div class=\"row\">\r\n    <span class=\"prop-header prop-label\">")
    ; __append(escapeFn(redirectURLTitle))
    ; __append("</span>\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"redirectType\" value=\"textOrNumber\" /> Text or Number</div>\r\n    <div class=\"col-md-12\"><input type=\"text\" name=\"textOrNumber\" value=\"")
    ; __append(escapeFn(textOrNumber))
    ; __append("\"")
    ; __append(escapeFn(textOrNumberReadOnly))
    ; __append("></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"redirectType\" value=\"fieldValue\" /> Value of a Field</div>\r\n    <div class=\"col-md-9\">\r\n        <input type=\"text\" name=\"fieldValue\" value=\"")
    ; __append(escapeFn(fieldValue))
    ; __append("\" readonly>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n        <button type=\"button\" class=\"btn btn-default hvr-glow\">Select</button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"redirectType\" value=\"special\" /> Special</div>\r\n    <div class=\"col-md-12\">\r\n        <select name=\"special\" ")
    ; __append(escapeFn(specialDisabled))
    ; __append(">\r\n            <option value=\"formStage\">App - Stage</option> \r\n            <option value=\"formRole\">App - Role</option> \r\n            <option value=\"formInstanceName\">App - Instance Name</option> \r\n        </select>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"redirectType\" value=\"userGroup\" /> Formula</div>\r\n    <div class=\"col-md-12\">\r\n        <div class=\"col-md-5\">\r\n            <button type=\"button\" class=\"btn btn-default hvr-glow\">Compose</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}